import { createAsyncThunk } from '@reduxjs/toolkit'
import { H_QUALITO_MODULE } from 'account/constants/AccessRulesConstants'
import ApplicationConf from 'conf/ApplicationConf'
import LogAction from 'log/actions/LogAction'
import i18n from 'simple-react-i18n'
import { REJECTED, IDLE } from 'store/DataManagerConstants'
import ToastrAction from 'toastr/actions/ToastrAction'
import { genericPromise } from 'utils/ActionUtils'
import { isAuthorized } from 'utils/HabilitationUtil'

const QualityThunk = {
    fetchQualitometersListSpecific: createAsyncThunk(
        'fetchQualitometersListSpecific',
        async (_, { rejectWithValue, dispatch }) => {
            try {
                const response = await genericPromise(ApplicationConf.qualitometer.listSpecific(), 'GET')
                return response
            } catch (err) {
                dispatch(LogAction.logError(`${i18n.fetchError} ${i18n.qualitometers} : ${err}`))
                dispatch(ToastrAction.error(`${i18n.fetchError} ${i18n.qualitometers}`))
                return rejectWithValue(err)
            }
        },
        {
            condition: (arg = { forceFetch: false }, { getState }) => {
                const state = getState()
                if (!isAuthorized(H_QUALITO_MODULE, state)) {
                    return false
                }
                const { qualitometersListSpecificStatus } = state.DataManagerReducer.quality
                if (arg.forceFetch) {
                    return qualitometersListSpecificStatus !== REJECTED
                }
                return qualitometersListSpecificStatus === IDLE
            },
            dispatchConditionRejection: true,
        },
    ),
}

export default QualityThunk